import { Pipe, PipeTransform } from "@angular/core";
import { ItemSource } from "app/js/src/domain/item-source";
@Pipe({
  name: "TitleFilterPipe",
})
export class TitleFilterPipe implements PipeTransform {
  transform(items: Array<ItemSource>, searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter((it) => {
      return it.name.toLowerCase().includes(searchText);
    });
  }
}
